import { type SoapSet } from '@/features/soap-masters'

// 定型文 1 件の見出し行 (分類 / 見出し の連結)。挿入の toast にも一覧の行にも同じ文字列を使う。
export const soapSetLabel = (soapSet: SoapSet): string =>
  [soapSet.condition1, soapSet.condition2].filter(Boolean).join(' / ')

// 区分の無い定型文か。back の不変条件により、区分なし行を含めるのは 1 行のときだけなので
// 「1 行で soap_type が null」以外の混在は起きない (anycompass.serializers 参照)。
export const isUntypedSet = (soapSet: SoapSet): boolean =>
  soapSet.lines.length === 1 && soapSet.lines[0].soap_type === null

// 作成者と行数の副題。**作成者が空なら中黒を出さない**
// (移行元 CSV に作成者列が無い経路があり、そのままだと中黒だけが浮く)。
export const soapSetMeta = (soapSet: SoapSet): string =>
  [soapSet.author_name, `${soapSet.lines.length}行`]
    .filter(Boolean)
    .join(' ・ ')
